import React from "react";

export default function renderIcon({
  width = 21,
  height = 21,
  color = "#9ca2b8",
  isActive = false,
}) {
  return !isActive ? (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2045_7204)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="white"
        />
        <path
          d="M11.9983 23.1426C18.1524 23.1426 23.1412 18.1538 23.1412 11.9998C23.1412 5.84576 18.1524 0.856934 11.9983 0.856934C5.8443 0.856934 0.855469 5.84576 0.855469 11.9998C0.855469 18.1538 5.8443 23.1426 11.9983 23.1426Z"
          stroke="#4B247E"
        />
      </g>
      <defs>
        <clipPath id="clip0_2045_7204">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2045_7201)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="white"
        />
        <path
          d="M11.9983 23.1426C18.1524 23.1426 23.1412 18.1538 23.1412 11.9998C23.1412 5.84576 18.1524 0.856934 11.9983 0.856934C5.8443 0.856934 0.855469 5.84576 0.855469 11.9998C0.855469 18.1538 5.8443 23.1426 11.9983 23.1426Z"
          stroke="#4B247E"
        />
        <path
          d="M12.0011 20.5716C16.735 20.5716 20.5725 16.734 20.5725 12.0001C20.5725 7.26627 16.735 3.42871 12.0011 3.42871C7.26725 3.42871 3.42969 7.26627 3.42969 12.0001C3.42969 16.734 7.26725 20.5716 12.0011 20.5716Z"
          fill="#4B247E"
        />
      </g>
      <defs>
        <clipPath id="clip0_2045_7201">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
